'use client';

import { forwardRef } from 'react';
import type { VideoHTMLAttributes } from 'react';
import { usePrefersReducedMotion } from '@/hooks';

/**
 * Drop-in replacement for `<video>` that disables `autoPlay` for users with
 * `prefers-reduced-motion: reduce` (WCAG 2.2.2, first layer). Those users see
 * the static poster / first frame instead of the looping video; everyone else
 * gets the original behavior.
 *
 * It's a client component, so it can be dropped into server components too
 * (e.g. the video heroes that aren't `'use client'`).
 */
export const MotionSafeVideo = forwardRef<
  HTMLVideoElement,
  VideoHTMLAttributes<HTMLVideoElement>
>(function MotionSafeVideo({ autoPlay, children, ...rest }, ref) {
  const prefersReducedMotion = usePrefersReducedMotion();
  return (
    <video ref={ref} {...rest} autoPlay={!!autoPlay && !prefersReducedMotion}>
      {children}
    </video>
  );
});

export default MotionSafeVideo;
